import React from 'react';
import { FormattedMessage } from 'react-intl';

import RefreshIcon from '@/assets/icons/refresh.svg';
import { CloseIcon } from '@/components/icons/close';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';

interface RefreshJobDataBannerProps {
  onClose: () => void;
}

export function RefreshJobDataBanner({ onClose }: RefreshJobDataBannerProps) {
  return (
    <div className="shadow-base flex h-9 items-center gap-2 rounded border border-blue-600 bg-blue-50 p-2 md:w-[720px]">
      <Button
        type="button"
        variant="icon"
        size="icon"
        aria-label="Refresh page"
        className="flex h-6 w-6 items-center justify-center hover:!bg-blue-50"
        onClick={() => window.location.reload()}
      >
        <img src={RefreshIcon} alt="refresh-data" />
      </Button>
      <Typography variant="subtitle1" className="w-full">
        <FormattedMessage
          defaultMessage="Please refresh the page to see your updates from Hire"
          description="Hint after requisition data sync: reload to show latest from ATS"
        />
      </Typography>
      <Button
        type="button"
        variant="icon"
        size="icon"
        onClick={onClose}
        className="flex h-6 w-6 items-center justify-center hover:!bg-blue-50"
      >
        <CloseIcon className="text-blue-600" />
      </Button>
    </div>
  );
}
